module.exports = __webpack_public_path__ + "img/round-check.ec4b4ccf.svg";